import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface UpdatesState {
    pendingUpdates: {
        team: boolean
        profile: boolean
    }
}

const initialState: UpdatesState = {
    pendingUpdates: {
        team: false,
        profile: false
    }
}

export const updatesSlice = createSlice({
    name: 'updates',
    initialState,
    reducers: {
        setTeamUpdatePending: (state, action: PayloadAction<boolean>) => {
            state.pendingUpdates.team = action.payload
        },
        setProfileUpdatePending: (state, action: PayloadAction<boolean>) => {
            state.pendingUpdates.profile = action.payload
        }
    }
})

export const {setTeamUpdatePending, setProfileUpdatePending} = updatesSlice.actions

export const selectHasPendingUpdates = (state: { updates: UpdatesState }) =>
    state.updates.pendingUpdates.team || state.updates.pendingUpdates.profile

export const selectTeamUpdatePending = (state: { updates: UpdatesState }) =>
    state.updates.pendingUpdates.team

export const selectProfileUpdatePending = (state: { updates: UpdatesState }) =>
    state.updates.pendingUpdates.profile

export default updatesSlice.reducer
